var map = {
	"./en/privacy.txt": [
		37644,
		80
	],
	"./en/vision.txt": [
		86386,
		89
	],
	"./fr/privacy.txt": [
		2021,
		422
	],
	"./fr/vision.txt": [
		10346,
		759
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7904;
module.exports = webpackAsyncContext;